import * as React from 'react';
import { useAppContext } from '../../pages/App/AppContextProvider';

interface IFeature {
  children: React.JSX.Element;
  fallback?: React.JSX.Element | null;
  featureName: string;
}

export function useHasFeature(featureName: IFeature['featureName']): boolean {
  const { globalFeatures } = useAppContext();

  return globalFeatures.findIndex((feature: { name: string }) => feature.name === featureName) !== -1;
}

const Feature = ({ children, fallback = null, featureName }: IFeature): React.JSX.Element => {
  const hasFeature = useHasFeature(featureName);

  return hasFeature ? children : fallback || <>{false}</>;
};

export default Feature;
